import React from 'react';
import styled from 'styled-components'
import PropTypes from 'prop-types';
import {maxWidth} from "styled-system";
import {Switch} from '@smooth-ui/core-sc'

import {Box, Flex, Heading, Text} from 'rebass'

const Wrapper = styled(Box)`
${maxWidth}
`

Wrapper.defaultProps = {
	maxWidth: ['400px']
}

const CustomSwitch = styled(Switch)({
	'.sui-switch-ball': {
		backgroundColor: 'white !important',
		width: '28px',
		height: '28px',
		marginTop: '5px'
	},
})
const SwitchInput = props => {
	const {onChange,name,  value, title, description, headingSize} = props
	return (
		<Wrapper>
			<Flex mt={4} flexDirection={'row'} flexWrap={'wrap'} justifyContent={'space-between'}>
				<Heading fontSize={headingSize}>{title}</Heading>
				<Flex flexWrap={'wrap'} flexDirection={'column'}>
					<CustomSwitch name={name} checked={value} onChange={onChange} alignSelf={'end'} height={'28px'}/>
				</Flex>
			</Flex>


			<Text color={'metaText'} fontSize={'15px'}>{description}</Text>
		</Wrapper>
	);
};

SwitchInput.propTypes = {
	onChange: PropTypes.func,
	value: PropTypes.bool,
	title: PropTypes.string,
	description: PropTypes.string,
	name: PropTypes.string,
	headingSize: PropTypes.number
};

SwitchInput.defaultProps = {
	value: false,
	title: "Switch Input",
	description: "By switching on the switch, the switch will be on.",
	name: "switch-input",
	onChange: () => console.log('switched'),
	headingSize: 36
};

export default SwitchInput;
